<template>
  <section>
    <div class="container-fluid h-page">

      <div class="blur">
        <div class="white-bgg"></div>
        <div class="img-bgg"
          :style="`background-image:url('https://pic.imamhussain.org/photos/preview/${sliderActive.file}')`">
        </div>
      </div>
      <div class="row">
        <div class="col-md-1 layer"></div>
        <div class="col-md-10 layer">

          <Slider @change="sliderChange" :autoPlay="true" :thumbs="true" :autoPlayDelay="5000" />
          <div class="col-md-12  " style="height:30px"></div>
        




        </div>
        <div class="col-md-1 layer"></div>
      </div>
    </div>
  </section>
</template>
<script>
  import Slider from './Slider.vue'
  export default {
    components: {
      Slider
    },
    data() {
      return {
        sliderActive: [],
      }
    },
    methods: {
      sliderChange(slide) {
        this.sliderActive = slide;
      }
    },
  }
</script>